import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { CustomerService } from '../../customer/services/customer.service';
import { UtilService } from '../../service/util.service';
import { IntegerValidator } from '../../shared/validation/integer-validator.function';
import { Customer } from '../../customer/model/customer.model';
import { ModalType } from '../model/customer-modal-type.enum';

@Component({
  selector: 'select-customer-modal',
  templateUrl: './select-customer-modal.component.html',
  styleUrls: ['./select-customer-modal.component.css']
})
export class SelectCustomerModalComponent implements OnInit {

  customerModalType = ModalType.SEARCH;

  ModalType = ModalType;

  @Input() currentCustomerNumber: number;
  selectCustomerModalForm: FormGroup;
  customerFound: boolean = null;
  loading = false;
  @ViewChild("customerNumInput") customerNumInput: ElementRef<HTMLElement>;

  constructor(
    public activeModal: NgbActiveModal,
    private service: CustomerService,
    private utilService: UtilService) {
  }

  ngOnInit() {
    if (this.currentCustomerNumber) {
      this.customerFound = true;
    }
    this.createForm();
  }

  private createForm() {
    this.selectCustomerModalForm = new FormGroup({
      'existingCust': new FormControl('Y', [Validators.required]),
      'customerNum': new FormControl(this.currentCustomerNumber, [Validators.required, Validators.maxLength(10), IntegerValidator()])
    });
  }

  onSubmit() {
    this.activeModal.close(this.selectCustomerModalForm.value.customerNum);
  }

  cancel() {
    this.activeModal.dismiss();
  }

  get customerNum() {
    return this.selectCustomerModalForm.get('customerNum');
  }

  checkCustomerExists(): void {
    if (this.selectCustomerModalForm.controls.customerNum.valid && this.customerNum.value !== null) {
      this.loading = true;
      this.service.getCustomer(this.customerNum.value)
        .subscribe(customer => {
          if (customer !== null) {
            this.customerFound = true;
          } else {
            this.customerFound = false;
          }
          this.loading = false;
          this.customerNumInput.nativeElement.focus();
        });
    }
  }

  onKeyDown() {
    this.customerFound = null;
  }

  onKeyPress($event: KeyboardEvent): boolean {
    if ($event.keyCode === 13) {
      this.checkCustomerExists();
      return false;
    } else if ($event.keyCode < 48 || $event.keyCode > 57) {
      return false;
    } else {
      return true;
    }
  }

  onPaste($event: ClipboardEvent) {
    if (!this.utilService.isInteger($event.clipboardData.getData('text/plain'))) {
      $event.preventDefault();
    } else {
      this.customerFound = null;
    }
  }

  goToAdd(): void {
    this.customerModalType = ModalType.ADD;
  }

  cancelAdd(): void {
    this.customerModalType = ModalType.SEARCH;
  }

  acceptAdd(customer: Customer): void {
    this.activeModal.close(customer.customerNumber);
  }

}
